module.exports = __webpack_public_path__ + "2d197f635a7969303233a48ecef38c87.png";